export type MinMaxValue = [value: number, delta: number] | [value: number, min: number, max: number];
export function getValue(value: MinMaxValue) {
    return value[0];
}
export function getMin(value: MinMaxValue) {
    if (value.length === 2) return value[0] - value[1];
    return value[1];
}
export function getMax(value: MinMaxValue) {
    if (value.length === 2) return value[0] + value[1];
    return value[2];
}